export { default } from 'modules/Seats/SeatMetrics/SeatTypes'
